import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppInviteData } from 'src/lib/fliko/models/appInvite.data';
import { AppInviteRequest } from 'src/lib/fliko/models/http/appInviteRequest.data';
import { Nullish } from 'src/lib/fliko/types/typeish.type';
import { FunctionsApiService, Result } from 'src/app/shared/services/functions-api.service';
import { DatabaseService } from 'src/app/shared/services/database.service';

@Injectable({ providedIn: 'root' })
export class AppInviteService {
  constructor(
    private dbSrv: DatabaseService,
    private fas: FunctionsApiService
  ) {}

  /**
   * @path /appInvite/$estateId/
   * @key residentId or subcontractorId
   */
  private get appInvite() {
    return this.dbSrv.estateFactory.getCollectionReadOnly<AppInviteData>('appInvite/$eId');
  }

  public getInvites$(): Observable<AppInviteData[]> {
    return this.appInvite.getList();
  }

  public getUserInviteData$(userId: string): Observable<AppInviteData | Nullish> {
    return this.appInvite.getElement(userId);
  }

  public requestAppInviteUpdate(requestData: AppInviteRequest): Result<boolean> {
    return this.fas.callFunction<boolean>('appInviteProcess', requestData);
  }
}
